var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.paths),function(path,idx){return [_vm._t("default",function(){return [(_vm.noTitle)?_c('img',{class:_vm.classList,attrs:{"src":path.url}}):_c('img',{class:_vm.classList,attrs:{"src":path.url,"alt":path.name}})]},{"path":{...path, idx, size: _vm.paths.length}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }